import { Component } from '@angular/core';
import { InvestmentFlowService } from '../../../../core/services/Investment-flow/investment-flow.service';

@Component({
  selector: 'app-final-join-section',
  imports: [],
  templateUrl: './final-join-section.component.html',
  styleUrl: './final-join-section.component.css',
})
export class FinalJoinSectionComponent {
constructor(public flow: InvestmentFlowService){}
}
